import { put, takeLatest } from "redux-saga/effects";
import {
  GET_PROFILE_DETAILS,
  GET_PROFILE_DETAILS_FAILED,
  GET_PROFILE_DETAILS_INIT,
  GET_PROFILE_DETAILS_SUCCESS,
  GET_ALLOCATOR_Strategy,
  GET_ALLOCATOR_Strategy_INIT,
  GET_ALLOCATOR_Strategy_SUCCESS,
  GET_ALLOCATOR_Strategy_FAILED,
  UPDATE_ALLOCATOR_STRATEGY_INIT,
  UPDATE_ALLOCATOR_STRATEGY_SUCCESS,
  UPDATE_ALLOCATOR_STRATEGY_FAILED,
  UPDATE_ALLOCATOR_STRATEGY,
  GET_STRATEGY,
  GET_STRATEGY_SUCCESS,
  GET_STRATEGY_INIT,
  GET_STRATEGY_FAILED,
  GET_ALL_INVESTOR,
  GET_ALL_INVESTOR_INIT,
  GET_ALL_INVESTOR_SUCCESS,
  GET_ALL_INVESTOR_FAILED,
  UPDATE_TENET_DETIALS,
  UPDATE_TENET_DETIALS_INIT,
  UPDATE_TENET_DETIALS_SUCCESS,
  UPDATE_TENET_DETIALS_FAILED,
  UPDATE_COVERIMAGE_INIT,
  UPDATE_COVERIMAGE_SUCCESS,
  UPDATE_COVERIMAGE_FAILED,
  UPDATE_COMPANYLOGO_INIT,
  UPDATE_COMPANYLOGO_SUCCESS,
  UPDATE_COMPANYLOGO_FAILED,
  UPDATE_COVERIMAGE,
  UPDATE_COMPANYLOGO,
  GET_COMPANY_POST_FEED_INIT,
  GET_COMPANY_POST_FEED_SUCCESS,
  GET_COMPANY_POST_FEED_FAILED,
  GET_COMPANY_POST_FEED,
  GET_COMPANY_USERS_INIT,
  GET_COMPANY_USERS_SUCCESS,
  GET_COMPANY_USERS_FAILED,
  GET_COMPANY_USERS,
  GET_FUND_SPOTLIGHTS_INIT,
  GET_FUND_SPOTLIGHTS_SUCCESS,
  GET_FUND_SPOTLIGHTS_FAILED,
  GET_FUND_SPOTLIGHTS,
  CREATE_ALLOCATOR_INFO_INIT,
  CREATE_ALLOCATOR_INFO_SUCCESS,
  CREATE_ALLOCATOR_INFO_FAILED,
  GET_ALLOCATOR_INFO_INIT,
  GET_ALLOCATOR_INFO_SUCCESS,
  GET_ALLOCATOR_INFO_FAILED,
  UPDATE_ALLOCATOR_INFO_INIT,
  UPDATE_ALLOCATOR_INFO_SUCCESS,
  UPDATE_ALLOCATOR_INFO_FAILED,
  CREATE_ALLOCATOR_INFO,
  GET_ALLOCATOR_INFO,
  UPDATE_ALLOCATOR_INFO,
  UPDATE_IDP_INIT,
  UPDATE_IDP_SUCCESS,
  UPDATE_IDP_FAILED,
  UPDATE_FSI_INIT,
  UPDATE_FSI_SUCCESS,
  UPDATE_FSI_FAILED,
  UPDATE_NDE_INIT,
  UPDATE_NDE_SUCCESS,
  UPDATE_NDE_FAILED,
  UPDATE_FSI,
  UPDATE_IDP,
  UPDATE_NDE,
  UPDATE_IC_INIT,
  UPDATE_IC_SUCCESS,
  UPDATE_IC_FAILED,
  UPDATE_IC
} from "./constants";
import { getUtil, postUtil, putUtil } from "../../services/axiosClient";
import { API } from "../../utils/Constant";
import GenerateUrl from "@hedgefund/shared/src/GenerateUrl";

const getPostFeed = [
  { keyword: "page", value: "page" },
  { keyword: "perPage", value: "perPage" },
]

function* getProfileDetail() {
  yield put({ type: GET_PROFILE_DETAILS_INIT });
  try {
    const res = yield getUtil(API.GetProfileDetail);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_PROFILE_DETAILS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_PROFILE_DETAILS_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_PROFILE_DETAILS_FAILED });
    throw new Error(error);
  }
}

function* getAllocatorStrategySaga() {
  yield put({ type: GET_ALLOCATOR_Strategy_INIT });
  try {
    const res = yield getUtil(API.AllocatorStrategy);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_ALLOCATOR_Strategy_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALLOCATOR_Strategy_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_ALLOCATOR_Strategy_FAILED });
    throw new Error(error);
  }
}

function* strategySaga() {
  yield put({ type: GET_STRATEGY_INIT });
  try {
    const res = yield getUtil(API.Strategy);
    if (res?.status === 200) {
      const { data } = res;

      yield put({ type: GET_STRATEGY_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_STRATEGY_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_STRATEGY_FAILED });
    throw new Error(error);
  }
}

function* updateAllocatorStratgySaga({ payload }) {
  yield put({ type: UPDATE_ALLOCATOR_STRATEGY_INIT });
  try {
    const res = yield postUtil(API.UpdateAllocatorStrategy, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: UPDATE_ALLOCATOR_STRATEGY_SUCCESS,
        payload: data.result,
      });
    } else {
      yield put({ type: UPDATE_ALLOCATOR_STRATEGY_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_ALLOCATOR_STRATEGY_FAILED });
    throw new Error(error);
  }
}

function* getallInvestorsSaga() {
  yield put({ type: GET_ALL_INVESTOR_INIT });
  try {
    const res = yield getUtil(API.InvestorType);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALL_INVESTOR_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALL_INVESTOR_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_ALL_INVESTOR_FAILED });
    throw new Error(error);
  }
}


function* updateTenetDetailSaga({ payload, onSuccess }) {
  yield put({ type: UPDATE_TENET_DETIALS_INIT });
  try {
    const res = yield putUtil(API.UpdateTenant, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_TENET_DETIALS_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_TENET_DETIALS_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_TENET_DETIALS_FAILED });
    throw new Error(error);
  }
}

function* updateTenanttCoverImageSaga({ payload, onSuccess, onCloseModal }) {
  yield put({ type: UPDATE_COVERIMAGE_INIT });
  try {
    const res = yield putUtil(API.UpdateTenantCoverImage, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_COVERIMAGE_SUCCESS, payload: data.result });
      onSuccess();
      onCloseModal();
    } else {
      yield put({ type: UPDATE_COVERIMAGE_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_COVERIMAGE_FAILED });
    throw new Error(error);
  }
}

function* updateTenantCompanyLogoSaga({ payload, onSuccess, onCloseModal }) {
  yield put({ type: UPDATE_COMPANYLOGO_INIT });
  try {
    const res = yield putUtil(API.UpdateTenantCompantLogo, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_COMPANYLOGO_SUCCESS, payload: data.result });
      onSuccess();
      onCloseModal();
    } else {
      yield put({ type: UPDATE_COMPANYLOGO_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_COMPANYLOGO_FAILED });
    throw new Error(error);
  }
}

function* getCurrentCompanyPostFeedSaga({ payload}) {
  yield put({ type: GET_COMPANY_POST_FEED_INIT });
  try {
    const url = API.CurrentCompanyPostFeed + GenerateUrl(payload, getPostFeed);

    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_COMPANY_POST_FEED_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_COMPANY_POST_FEED_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_COMPANY_POST_FEED_FAILED });
    throw new Error(error);
  }
}

function* getCurrentCompanyUsersSaga() {
  yield put({ type: GET_COMPANY_USERS_INIT });
  try {
    const res = yield getUtil(API.GetTenantUsers);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_COMPANY_USERS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_COMPANY_USERS_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_COMPANY_USERS_FAILED });
    throw new Error(error);
  }
}

function* getFundSpotlightSaga({ payload }) {
  yield put({ type: GET_FUND_SPOTLIGHTS_INIT });
  try {
    let url = `${API.FundSpotlight}?Keyword=${payload.keyword}&Page=${payload.page}&PerPage=${payload.limit}`;
    const res = yield getUtil(url);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_FUND_SPOTLIGHTS_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_FUND_SPOTLIGHTS_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_FUND_SPOTLIGHTS_FAILED });
    throw new Error(error);
  }
}


function* createAllocatorInfoSaga({ payload, onSuccess }) {
  yield put({ type: CREATE_ALLOCATOR_INFO_INIT });
  try {
    const res = yield postUtil(API.CreateAllocatorInfo, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({
        type: CREATE_ALLOCATOR_INFO_SUCCESS,
        payload: data.result,
      });
      onSuccess();
    } else {
      yield put({ type: CREATE_ALLOCATOR_INFO_FAILED });
    }
  } catch (error) {
    yield put({ type: CREATE_ALLOCATOR_INFO_FAILED });
    throw new Error(error);
  }
}

function* getAllocatorInfoSaga() {
  yield put({ type: GET_ALLOCATOR_INFO_INIT });
  try {
    const res = yield getUtil(API.GetAllocatorInfo);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: GET_ALLOCATOR_INFO_SUCCESS, payload: data.result });
    } else {
      yield put({ type: GET_ALLOCATOR_INFO_FAILED });
    }
  } catch (error) {
    yield put({ type: GET_ALLOCATOR_INFO_FAILED });
    throw new Error(error);
  }
}


function* updateAllocatorInfoSaga({ payload, onSuccess }) {
  yield put({ type: UPDATE_ALLOCATOR_INFO_INIT });
  try {
    const res = yield postUtil(API.UpdateAllocatorInfo, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_ALLOCATOR_INFO_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_ALLOCATOR_INFO_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_ALLOCATOR_INFO_FAILED });
    throw new Error(error);
  }
}

function* updateIDPSaga({ payload, onSuccess }) {
  yield put({ type: UPDATE_IDP_INIT });
  try {
    const res = yield postUtil(API.UpdateIDP, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_IDP_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_IDP_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_IDP_FAILED });
    throw new Error(error);
  }
}

function* updateFSISaga({ payload, onSuccess }) {
  yield put({ type: UPDATE_FSI_INIT });
  try {
    const res = yield postUtil(API.UpdateFSI, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_FSI_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_FSI_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_FSI_FAILED });
    throw new Error(error);
  }
}

function* updateNDESaga({ payload, onSuccess }) {
  yield put({ type: UPDATE_NDE_INIT });
  try {
    const res = yield postUtil(API.UpdateNDE, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_NDE_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_NDE_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_NDE_FAILED });
    throw new Error(error);
  }
}

function* updateICSaga({ payload, onSuccess }) {
  yield put({ type: UPDATE_IC_INIT });
  try {
    const res = yield postUtil(API.UpdateIC, payload);
    if (res?.status === 200) {
      const { data } = res;
      yield put({ type: UPDATE_IC_SUCCESS, payload: data.result });
      onSuccess();
    } else {
      yield put({ type: UPDATE_IC_FAILED });
    }
  } catch (error) {
    yield put({ type: UPDATE_IC_FAILED });
    throw new Error(error);
  }
}

export function* profile() {
  yield takeLatest(GET_PROFILE_DETAILS, getProfileDetail);
  yield takeLatest(GET_ALLOCATOR_Strategy, getAllocatorStrategySaga);
  yield takeLatest(GET_STRATEGY, strategySaga);
  yield takeLatest(UPDATE_ALLOCATOR_STRATEGY, updateAllocatorStratgySaga);
  yield takeLatest(GET_ALL_INVESTOR, getallInvestorsSaga);
  yield takeLatest(UPDATE_TENET_DETIALS, updateTenetDetailSaga);
  yield takeLatest(UPDATE_COVERIMAGE, updateTenanttCoverImageSaga);
  yield takeLatest(UPDATE_COMPANYLOGO, updateTenantCompanyLogoSaga);
  yield takeLatest(GET_COMPANY_POST_FEED, getCurrentCompanyPostFeedSaga);
  yield takeLatest(GET_COMPANY_USERS, getCurrentCompanyUsersSaga);
  yield takeLatest(GET_FUND_SPOTLIGHTS, getFundSpotlightSaga);
  yield takeLatest(CREATE_ALLOCATOR_INFO, createAllocatorInfoSaga);
  yield takeLatest(GET_ALLOCATOR_INFO, getAllocatorInfoSaga);
  yield takeLatest(UPDATE_ALLOCATOR_INFO, updateAllocatorInfoSaga);
  yield takeLatest(UPDATE_FSI, updateFSISaga);
  yield takeLatest(UPDATE_IDP, updateIDPSaga);
  yield takeLatest(UPDATE_NDE, updateNDESaga);
  yield takeLatest(UPDATE_IC, updateICSaga);

}
